<template>
  <div id="header" class="header nobg">
    <div class="banxin">
      <a href="https://bmobapp.com/" class="logo">
        <img src="@/assets/img/logo.png" alt="Baas后端云" class="logo1" title="Bmob后端云-让移动开发更简单">
        <img src="@/assets/img/logo1.png" alt="Baas后端云" class="logo2" title="Bmob后端云-让移动开发更简单">
      </a>
      <a href="/" class="logo logo_min">
        <img src="@/assets/img/logo_1.png" alt="Baas后端云" class="logo1" title="Bmob后端云-让移动开发更简单">
        <img src="@/assets/img/logo1_1.png" alt="Baas后端云" class="logo2" title="Bmob后端云-让移动开发更简单">
      </a>
      <div id="min-nav" class="header-right">
        <!-- btns -->
        <div class="login-register">
          <div v-if="!isLogin">
            <a id="btn-login" :class="$route.path==='/login'?'active':''" href="/login">登录</a>
            <a class="btn-r" :class="$route.path==='/register'?'active':''" href="/register">注册</a>
          </div>
          <div v-else>
            <!-- <a v-if="isPromptSquareLogin" class="enter btn-r prompt-btn" target="_self" :href="createUrl('my-prompts')">我的提示词</a> -->
            <a class="enter btn-r ml10" target="_blank" :href="createUrl('app/list')">我的控制台</a>
          </div>
        </div>
        <!-- nav -->
        <ul v-if="$route.path.includes('/repository')" id="nav" class="nav">
          <li><span /><a :href="$store.getters.docUrl + '/'">文档</a></li>
          <li class="on"><span /><a href="/repository/index">知识库</a></li>
          <li><span /><a href="https://github.com/bmob">开源</a></li>
        </ul>
        <ul v-else-if="['/about','/service','/privacy','/friendlink','/partners','/school'].indexOf($route.path)===-1 && !$route.path.includes('/site/news')" id="nav" class="nav">
          <li :class="$route.path==='/'?'on':''"><span /><a href="/">首页</a></li>
          <li :class="['/cloud','/shop/index','/weixin','/sms','/mcp','/prompt'].indexOf($route.path)>-1?'on':''">
            <span /><a :href="createUrl('cloud')" class="hidden-xs">产品</a>
            <ul class="box-menu box-menu-col">
              <li><a class="new_sale" :href="createUrl('cloud')">云数据库<span>热</span></a></li>
              <li><a href="/mcp" class="new_sale">MCP 服务<span>新</span></a></li>
              <li><a :href="createUrl('iot')" class="new_sale">物联网iot</a></li>
              <li><a href="http://www.bmobcloud.com/" target="_blank" class="new_sale">CodeFlow<span>新</span></a></li>
              <li><a href="/shop/index" class="new_sale">源码通</a></li>
            </ul>
            <ul class="box-menu box-menu-col">

              <li><a :href="createUrl('weixin')" class="new_sale">小程序</a></li>
              <li><a :href="createUrl('sms')" class="new_sale">短信验证码<span>促</span></a></li>
              <li><a :href="createUrl('hook')" class="new_sale">数据钩子</a></li>
              <li><a :href="createUrl('harmoney')" class="new_sale">鸿蒙SDK<span>新</span></a></li>
              <li><a href="/prompt" class="new_sale">提示词广场</a></li>
            </ul>
          </li>
          <li :class="$route.path==='/function'?'on':''"><span /><a :href="createUrl('function')" class="new_sale">云函数</a></li>
          <li :class="$route.path==='/prices'?'on':''"><span /><a href="/prices">价格</a></li>

          <li><span /><a :href="createUrl('ai')" class="new_sale">AI大模型</a></li>
          <li><span /><a :href="$store.getters.docUrl" target="_blank">文档</a></li>
        </ul>
        <!--  -->
        <ul v-else id="nav" class="nav" style="width:690px">
          <li :class="$route.path==='/about'?'on':''"><span /><a href="/about">公司简介</a>
          </li>
          <li :class="$route.path.includes('/site/news')?'on':''">
            <span /><a href="/site/news">新闻动态</a>
          </li>
          <!-- <li><span /><a href="http://www.lagou.com/gongsi/2480.html" target="_blank">加入我们</a></li> -->
          <li :class="$route.path==='/service'?'on':''"><span /><a href="/service">服务条款</a></li>
          <li :class="$route.path==='/privacy'?'on':''"><span /><a href="/privacy">隐私政策</a></li>
          <li :class="$route.path==='/school'?'on':''"><span /><a href="/school">客户院校</a></li>
          <!--   <li :class="$route.path==='/partners'?'on':''">
                        <span />
                        <a href="/partners">合作伙伴</a>
                    </li>
                    <li :class="$route.path==='/friendlink'?'on':''">
                        <span />
                        <a href="/friendlink">友情链接</a>
                    </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken, removeToken } from '@/utils/auth' // get token from cookie
import { checkLogin } from '@/api/backend'
export default {
  name: 'Header',
  props: {},
  data: function() {
    return {
      isLogin: getToken(),
      isPromptSquareLogin: false // 提示词广场登录状态
    }
  },
  mounted() {
    checkLogin().then(res => {
      if (res.msg == '用户未登录') {
        this.isLogin = false
        removeToken()
      }
    })

    // 检查提示词广场登录状态
    this.checkPromptSquareLogin()

    // 监听localStorage变化，实时更新提示词广场登录状态
    window.addEventListener('storage', this.handleStorageChange)

    // 监听提示词广场登录成功事件
    window.addEventListener('promptSquareLoginSuccess', this.handlePromptSquareLoginSuccess)

    // 跳转https
    if (location.protocol != 'https:' && (location.hostname == 'www.bmob.cn' || location.hostname == 'bmob.cn' || location.hostname == 'bmobapp.com')) {
      location.href = 'https:' + window.location.href.substring(window.location.protocol.length)
    }

    // eslint-disable-next-line no-undef
    responsiveNav('#min-nav')
    const b = $(window).width()
    if (b > 640) {
      $('#nav>li').hover(function() {
        $(this).children('ul').stop().fadeToggle(300)
        $(this).stop().toggleClass('nav-hover')
      })
    }
    $('#weixin').hover(function() { $('#weixin_qr').toggleClass('gaoliang') })
    if (b > 1000) {
      $('.user-msg').hover(function() {
        $(this).children('.logout').stop().slideDown(500)
        $(this).children('.glyphicon-menu-down').addClass('rota')
      }, function() {
        $(this).children('.logout').stop().slideUp(500)
        $(this).children('.glyphicon-menu-down').removeClass('rota')
      })
    } else {
      $('.user-msg').click(function() {
        $(this).children('.logout').stop().slideToggle(500)
      })
    }
    const that = this
    $('.user-msg .logout').click(function() {
      that.$store
        .dispatch('user/logout')
        .then(() => {
          that.$router.push({
            path: '/'
          })
        })
    })
  },

  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('promptSquareLoginSuccess', this.handlePromptSquareLoginSuccess)
  },
  methods: {
    createUrl: function(route, params) {
      let paramStr = ''
      for (const key in params) {
        paramStr += '&' + key + '=' + params[key]
      }
      if (paramStr) {
        paramStr = '?' + paramStr.substring(1, paramStr.length)
      }
      if (route.indexOf('/') !== 0) {
        route = '/' + route
      }
      return process.env.VUE_APP_BASE_URL + route + paramStr
    },

    // 检查提示词广场登录状态
    checkPromptSquareLogin() {
      try {
        const promptSquareToken = localStorage.getItem('promptSquareToken')
        const promptSquareUser = localStorage.getItem('promptSquareUser')

        // 检查是否存在有效的提示词广场登录信息
        if (promptSquareToken && promptSquareUser) {
          const userInfo = JSON.parse(promptSquareUser)
          // 检查token是否存在且用户信息完整
          if (userInfo.username && userInfo.token) {
            this.isPromptSquareLogin = true
            return
          }
        }

        this.isPromptSquareLogin = false
      } catch (error) {
        console.log('检查提示词广场登录状态失败:', error)
        this.isPromptSquareLogin = false
      }
    },

    // 处理localStorage变化
    handleStorageChange(event) {
      // 只关心提示词广场相关的存储变化
      if (event.key === 'promptSquareToken' || event.key === 'promptSquareUser') {
        this.checkPromptSquareLogin()
      }
    },

    // 处理提示词广场登录成功事件
    handlePromptSquareLoginSuccess(event) {
      console.log('Header接收到提示词广场登录成功事件:', event.detail)
      // 立即更新登录状态
      this.checkPromptSquareLogin()
    }
  }
}
</script>

<style scoped>
.box-menu {
  min-width: 140px;
  overflow: hidden;
}

.box-menu-col {
  float: left;
  width: 50%;
}

.box-menu-col li {
  width: 100%;
}

/* 让导航 li 成为下拉菜单的定位容器，方便对齐具体菜单 */
#nav > li {
  position: relative;
}

/* 修复产品下拉菜单两列叠在一起，并让浮层左侧与“产品”菜单左对齐 */
#nav > li > ul.box-menu.box-menu-col {
  position: absolute;
  top: 70px !important;          /* 与原下拉保持同一高度 */
  width: 190px !important;       /* 每列宽度 */
  left: 0 !important;            /* 第一列左侧对齐当前 li */
  margin-left: 0 !important;
  z-index: 10;
  background: #fff !important;   /* 白色背景 */
  padding: 6px 0;
  min-height: 180px;             /* 固定一个最小高度，让两列底部对齐 */
}

#nav > li > ul.box-menu.box-menu-col:last-of-type {
  left: 190px !important;        /* 第二列紧挨第一列右侧，看起来是一整块 */
}

/* 让两列看起来是同一块卡片：只在左右两边做圆角和阴影 */
#nav > li > ul.box-menu.box-menu-col:first-of-type {
  border-radius: 6px 0 0 6px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

#nav > li > ul.box-menu.box-menu-col:last-of-type {
  border-radius: 0 6px 6px 0;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

/* 下拉菜单项样式微调，让整体更紧凑、美观 */
.box-menu-col li a {
  padding: 8px 14px !important;
  font-size: 13px;
  width: auto !important;
  white-space: nowrap;
  border: 0 !important;
  background: transparent !important;
}

.box-menu-col li a span {
  display: inline-block;
  margin-left: 4px;
  padding: 0 4px;
  font-size: 12px;
  line-height: 1.4;
  border-radius: 8px;
  background: #ffecec;
  color: #ff4d4f;
}

.box-menu-col li a.new_sale {
  position: relative;
}

.box-menu-col li a:hover {
  background: #f5f7fa !important;
  color: #008df9 !important;
}

/* 移动端：产品子菜单改为流式布局，不浮层盖住后面的菜单 */
@media screen and (max-width: 1000px) {
  #nav > li > ul.box-menu.box-menu-col {
    position: static !important;
    top: auto !important;
    left: auto !important;
    width: 100% !important;
    min-height: 0 !important;
    margin-left: 0 !important;
    z-index: 0;
    border-radius: 0;
    box-shadow: none;
    background: rgba(0, 0, 0, 0.12) !important;
    padding: 0;
  }
  #nav > li > ul.box-menu.box-menu-col:last-of-type {
    left: auto !important;
    border-radius: 0;
    box-shadow: none;
  }
  #nav > li > ul.box-menu.box-menu-col:first-of-type {
    border-radius: 0;
    box-shadow: none;
  }
  .box-menu-col {
    float: none !important;
    width: 100% !important;
  }
  .box-menu-col li a {
    color: rgba(255, 255, 255, 0.95) !important;
    padding: 10px 15px 10px 28px !important;
    width: 100% !important;
    box-sizing: border-box;
  }
  .box-menu-col li a:hover {
    background: rgba(255, 255, 255, 0.12) !important;
    color: #fff !important;
  }
}

.prompt-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #fff !important;
  border: none !important;
  min-width: 100px !important;
  text-align: center !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 12px !important;
}

.prompt-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  color: #fff !important;
}

.login-register .enter {
  padding: 8px 20px !important;
  border-radius: 4px !important;
  transition: all 0.3s !important;
  height: 36px !important;
  line-height: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 100px !important;
  text-align: center !important;
  font-size: 12px !important;
}

.login-register .enter:hover {
  opacity: 0.9;
  text-decoration: none;
}

/* 仅用于头部“我的控制台”按钮，避免白底看不见 */
.login-register .enter.ml10 {
  margin-left: 10px !important;
  background: linear-gradient(90deg, #409EFF 0%, #8971E3 100%) !important;
  color: #fff !important;
  border: none !important;
}

.login-register .enter.ml10:hover {
  opacity: 0.9;
}
</style>
